import { useQuery } from 'react-query';
import { client } from 'utils/api-client';

export function useMyHomeServices() {
  return useQuery('my-services', () =>
    client('services/myHomeServices').then((res) => res)
  );
}
